import {UpperCasePipe} from "@angular/common"
import {Component, input, ChangeDetectionStrategy} from "@angular/core"
import {PbrExport} from "@cm/material-maps-exporter"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-material-output-pbr-export-detail",
    imports: [UpperCasePipe],
    templateUrl: "./material-output-pbr-export-detail.component.html",
    styleUrl: "./material-output-pbr-export-detail.component.scss",
})
export class MaterialOutputPbrExportDetailComponent {
    readonly $exportSummary = input.required<PbrExport.Types.Settings>({alias: "exportSummary"})
    readonly $sourceInfo = input.required<string>({alias: "sourceInfo"})

    readonly workflowToString = PbrExport.Utils.workflowToString
    readonly engineToString = PbrExport.Utils.engineToString
    readonly normalYToString = PbrExport.Utils.normalYToString
    readonly resolutionToString = PbrExport.Utils.resolutionToString
}
